import gql from "graphql-tag";

import UserSettingsV2Fields from "lib/graphql/fragments/UserSettingsV2Fields";

import UserSettings from "../fragments/UserSettings";

export default gql`
  query Selfie {
    selfie {
      _id
      firstName
      lastName
      fullName
      email
      country
      isConnectedWithGoogle
      hasPasswordSet
      isPremium
      isTrialing
      isBlack
      isSiteAdmin
      isTrialing
      viewerCanPurchaseBlack
      viewerCanStartPremiumTrial
      pictureUrl
      signedUpAt
      intercom {
        appId
        verificationHash
      }
      blackSubscriptionPeriod {
        startDate
        endDate
        isSeptember23LaunchSale
        isRenewable
        renewUntil
      }
      ...UserSettings
      settingsV2 {
        ...UserSettingsV2Fields
      }
    }
  }

  ${UserSettings}
  ${UserSettingsV2Fields}
`;
